<template>
  <div class="d-flex align-items-center overflow-hidden">
    <div
      v-if="item.showTestPractice"
      class="d-block p-2 align-items-center justify-content-center font-weight-bolder w-100"
      style="font-size: 1rem"
    >
      <a href="javascript:void(0)" @click="$emit('testReferral', {}, 1)"
        ><font-awesome-icon :icon="['far', 'paper-plane']" class="mr-2" /> Send a test referral</a
      >
    </div>
    <template v-else-if="item.id">
      <div class="item-logo mr-3" style="min-width: 32px; width: 32px">
        <img v-if="item.logo" :src="item.logo" class="img-fluid" style="min-height: 30px; max-height: 40px" />
        <img v-else-if="item.id == DemoId" src="@/assets/svg/logo.svg" class="img-fluid" style="width: 32px" />
        <img
          v-else
          class="img-fluid rounded-circle"
          :src="`https://placehold.co/30/a8b1b1/eff3f3?font=lato&text=${item.name[0]}`"
        />

        <!-- <img v-else class="img-fluid " :src="`https://placehold.co/30/519f85/fff?font=lato&text=${item.name.split(' ').filter(s=>/^[a-zA-Z'\-,]+$/.test(s)).map(s=>s[0]).join('')}`" /> -->

        <!-- <img v-else src="@/assets/svg/logo.svg" class="img-fluid" style="width: 32px" /> -->
      </div>
      <div class="practice-info flex-grow-1 overflow-hidden">
        <span class="option__title d-block text-truncate">{{ item.name }}</span>
        <div class="d-flex">
          <span class="option__small">
            <font-awesome-icon
              v-if="item.isInNetwork"
              title="In your network"
              :icon="['fas', 'bookmark']"
              class="mr-2"
            /><template v-if="item.phone">{{ item.phone | phone }}&nbsp;&nbsp;•&nbsp;&nbsp;</template>{{ item.city }},
            {{ item.state
            }}<template v-if="item.distance"
              >&nbsp;&nbsp;•&nbsp;&nbsp;{{ parseFloat(item.distance).toFixed(1) }}mi</template
            ></span
          >
        </div>
        <div class="text-right" :style="{ marginBottom: item.doctors && item.doctors.length ? '0' : '28px' }">
          <doctor-list
            :doctors="item.doctors"
            :maxDoctors="5"
            :size="'sm'"
            :color="''"
            class="ml-auto mt-1"
            style="margin-left: 0px"
            :preventResizeOnHover="true"
          ></doctor-list>
        </div>
      </div>
      <div class="d-flex flex-column align-items-end justify-content-start align-self-start">
        <span v-if="item.id == DemoId" class="badge badge-warning mb-auto">Try refera!</span>
        <span v-else class="badge text-muted mb-auto font-weight-bolder">{{
          item.specialties.map((s) => PracticeTypesAbbr[s]).join(', ')
        }}</span>
        <span v-if="item.isSuggested && !user.is_public" class="badge text-hint font-italic font-weight-light mb-2"
          >suggested</span
        >
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DoctorList from '../network/DoctorList.vue'
export default {
  components: { DoctorList },
  props: { item: { required: true } },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('settings', ['PracticeTypesAbbr', 'DemoId']),
  },
}
</script>

<style>
</style>